import React from 'react';
import { applicantDisplayName } from '../steps.config';

class ApplicantHeaderChip extends React.Component {
  initials = (applicant, index) => {
    const first = (applicant.given_name || '').trim();
    const last = (applicant.family_name || '').trim();
    if (first || last) {
      return `${(first[0] || '').toUpperCase()}${(last[0] || '').toUpperCase()}`;
    }
    return String(index + 1);
  };

  render() {
    const { applicant, applicantIndex, totalApplicants, hint } = this.props;
    if (!applicant) return null;

    return (
      <div
        className="flex items-center gap-3 mb-6 rounded-2xl border px-3 py-2.5 sm:px-4 sm:py-3"
        style={{ backgroundColor: '#F5F6FA', borderColor: '#E5E7EB' }}
      >
        <span
          className="inline-flex items-center justify-center h-9 w-9 rounded-full text-sm font-bold flex-shrink-0"
          style={{ backgroundColor: '#7C5CFC', color: '#FFFFFF' }}
        >
          {this.initials(applicant, applicantIndex)}
        </span>
        <div className="min-w-0">
          <p className="text-[11px] uppercase tracking-wider text-[#6B7280] font-semibold">
            {hint || 'Completing this section for'}
          </p>
          <p className="text-sm sm:text-base font-bold text-[#1F2937] truncate">
            {applicantDisplayName(applicant, applicantIndex)}
            {typeof totalApplicants === 'number' && totalApplicants > 1 ? (
              <span className="ml-2 text-xs font-normal text-[#6B7280]">
                ({applicantIndex + 1} of {totalApplicants})
              </span>
            ) : null}
          </p>
        </div>
      </div>
    );
  }
}

export default ApplicantHeaderChip;
